export const SALE_CATEGORY_ID = '31';
export const PRESCRIPTION_CATEGORY_ID = '13';
export const PLA_CONTACT_LENSES_CATEGORY_ID = '276';
export const SUNGLASSES_CATEGORY_ID = '201';
export const EYEGLASSES_CATEGORY_ID = '5';
export const CONTACT_LENSES_CATEGORY_ID = '174';

export const GENDER_FROM_POPUP = 'genderFromPopup';
